module.exports = "https://static.futunn.com/components/common-redpacket-prize-list/images/bg.fa9e4d9f9c.png";